import {
  Component,
  EventEmitter,
  Input,
  NO_ERRORS_SCHEMA,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Dropdown, SelectItem } from 'primeng/primeng';

import { GLPolicyService } from '../../../services/gl-policy.service';
import { GlobalFilterService } from '../../../services/global-filter.service';
import { EventSearchGLPolicyHelper } from '../helpers/event-search.glPolicyHelper';

export enum AdjustmentType {
  Claim = 'OW',
  Remittance = 'CR',
}

@Component({
  selector: 'app-eventsearch-gl-policy-selection',
  templateUrl: './eventsearch-gl-policy-selection.html',
})
export class EventSearchGLPolicySelectionComponent implements OnInit {
  readonly PLACEHOLDER = 'Select Policy';
  readonly MAX_SCROLL_HEIGHT = '91px';
  //  TODO: Can we remove this default and inject this thru property binding? -JEB
  @Input()
  adjustmentType: AdjustmentType = AdjustmentType.Claim;
  @Output()
  policyChanged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('glPolicyDropdown')
  glPolicyDropdown: Dropdown;
  readonly glPolicyHelper: EventSearchGLPolicyHelper;
  readonly globalFilterService: GlobalFilterService;
  readonly glPolicyService: GLPolicyService;
  selectedPolicy: SelectItem;
  public policiesLoaded = false;
  readonly placeholder = this.PLACEHOLDER;
  public glPolicies: SelectItem[] = [];

  constructor(
    globalFilterService: GlobalFilterService,
    glPolicyService: GLPolicyService,
  ) {
    this.globalFilterService = globalFilterService;
    this.glPolicyService = glPolicyService;
  }
  ngOnInit(): void {
    this.initForm();
  }

  async initForm() {
    await this.glPolicyService
      .getGLPolicies(
        this.globalFilterService.selectedEnvironment.ClientId4Digit,
        this.adjustmentType,
      )
      .then((policies) => {
        let helper = new EventSearchGLPolicyHelper();
        this.glPolicies = helper.toSelectItems(policies);
        this.policiesLoaded = true;
      });
  }

  onSelectionChanged(event) {
    this.policyChanged.emit(event.value);
  }

  setInputFocus() {
    this.glPolicyDropdown.applyFocus();
  }

  reset() {
    this.glPolicyDropdown.resetFilter();
    this.glPolicyDropdown.selectedOption = this.PLACEHOLDER;
    this.glPolicyDropdown.focus = true;
    this.setInputFocus()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-gl-policy-selection/eventsearch-gl-policy-selection.component.ts